
export const contactPhone = '0943 001 123';
export const contactEmail = 'trantuan.doca@gmail.com';
